module.exports = __webpack_public_path__ + "static/media/logo-psihomaestru-3.c61a895c.png";